import { render, staticRenderFns } from "./ReferenceRecSimilars.vue?vue&type=template&id=eefe94fe&scoped=true&"
import script from "./ReferenceRecSimilars.vue?vue&type=script&lang=js&"
export * from "./ReferenceRecSimilars.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceRecSimilars.vue?vue&type=style&index=0&id=eefe94fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eefe94fe",
  null
  
)

export default component.exports